import appCommon from "./appCommon";
import appOnDevice from "./appOnDevice";
import deviceCommon from "./deviceCommon";
import deviceMotherboard from "./deviceMotherboard";
import deviceWAppLic from "./deviceWAppLic";
import deviceWoLic from "./deviceWoLic";
import deviceWProfileLic from "./deviceWProfileLic";
import kabinetUserActions from "./kabinetUserActions";
import licApp from "./licApp";
import licAppActivated from "./licAppActivated";
import licCommon from "./licCommon";
import licFileCreated from "./licFileCreated";
import licProfile from "./licProfile";
import licProfileActivated from "./licProfileActivated";
import licQuantityCreated from "./licQuantityCreated";
import licRangeCreated from "./licRangeCreated";
import licToEcr from "./licToEcr";
import licWoEcr from "./licWoEcr";
import profileCommon from "./profileCommon";
import profileOnDevice from "./profileOnDevice";
  

export const reportTypes = {
  deviceCommon,
  deviceMotherboard,
  deviceWAppLic,
  deviceWProfileLic,
  deviceWoLic,
  appCommon,
  appOnDevice,
  profileCommon,
  profileOnDevice,
  kabinetUserActions,
  licProfile,
  licApp,
  licCommon,
  licToEcr,
  licWoEcr,
  licProfileActivated,
  licAppActivated,
  licQuantityCreated,
  licRangeCreated,
  licFileCreated
};